import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Homepage from "./pages/Home.jsx";
import Aboutpage from "./pages/About";
import Portfolio from "./pages/Portfolio";
import LifeStylePortfolio from "./pages/LifeStylePortfolio.jsx";
import WeddingPortfolio from "./pages/WeddingPortfolio.jsx";
import BookNow from "./pages/BookNow.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import MaternityPortfolio from "./pages/MaternityPortfolio.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";

function App() {
  return (
    <div className=" w-full max-w-10xl">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route index element={<Homepage />} />
          <Route path="/about" element={<Aboutpage />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/lifestyle-portfolio" element={<LifeStylePortfolio />} />
          <Route path="/wedding-portfolio" element={<WeddingPortfolio />} />
          <Route path="/maternity-portfolio" element={<MaternityPortfolio />} />
          <Route path="/book-now" element={<BookNow />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
